import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { usePreviousPregnanciesChartsDataContext } from './hooks/usePreviousPregnanciesChartsDataContext';

export const PreviousPregnanciesQuantityDeathBirths = () => {
    const { chartData } = usePreviousPregnanciesChartsDataContext();


    return (
        <SimpleBars
            title={'Quantidade de Gestações Anteriores - Nascidos Mortos'}
            horizontal={false}
            subtitles={chartData?.previousPregnanciesQuantityDeathBirths?.map((item) => item.description)}
            values={chartData?.previousPregnanciesQuantityDeathBirths?.map((item) => item.total  ||  0)}
        />
    );
};
